import { NgModule } from "@angular/core";
import { DashboardModule } from "../dashboard/dashboard.module";
import { TourModule } from "../tour/tour.module";

@NgModule({
    imports: [
        DashboardModule,
        TourModule
    ]
})
export class GoalsModule {

}
